import { GraduationCap, Award, Users, HeartHandshake } from "lucide-react";
import { Reveal } from "./Reveal";

const ITEMS = [
  { icon: GraduationCap, text: "Graduação em Psicologia — UFTM" },
  { icon: Award, text: "Especialista em Saúde — FAMERP" },
  { icon: Users, text: "Pós-graduação em Terapia Familiar Sistêmica — FAMERP" },
  { icon: HeartHandshake, text: "+8 anos de prática clínica" },
];

const MARQUEE_WORDS = [
  "Atendimento online para todo o Brasil",
  "Escuta acolhedora e sem julgamentos",
  "Sigilo garantido pelo Código de Ética",
  "8+ anos de experiência clínica",
  "Especialista em Terapia Sistêmica Familiar",
  "Mudanças consistentes e duradouras",
];

export const Authority = () => (
  <section data-testid="authority-section" className="border-y border-bark/8 bg-bone/60 py-14">
    <div className="mx-auto max-w-7xl px-6 lg:px-10">
      <Reveal>
        <p className="text-center text-xs font-semibold uppercase tracking-[0.28em] text-moss">
          Formação e experiência a serviço do seu cuidado
        </p>
      </Reveal>
      <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {ITEMS.map((item, i) => (
          <Reveal key={item.text} delay={i * 0.1}>
            <div
              data-testid={`authority-item-${i}`}
              className="flex items-center gap-4 rounded-2xl bg-sand px-6 py-5 shadow-[0_8px_30px_rgba(0,0,0,0.04)]"
            >
              <item.icon className="h-6 w-6 shrink-0 text-copper" strokeWidth={1.6} />
              <p className="text-sm font-semibold leading-snug text-bark">{item.text}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>

    <div className="mt-14 overflow-hidden" data-testid="editorial-marquee">
      <div className="animate-marquee flex w-max items-center gap-10 whitespace-nowrap">
        {[...MARQUEE_WORDS, ...MARQUEE_WORDS].map((word, i) => (
          <span key={i} className="flex items-center gap-10">
            <span className="font-serif text-3xl font-medium italic text-bark/35 sm:text-4xl">
              {word}
            </span>
            <span className="h-1.5 w-1.5 rounded-full bg-clay/60" />
          </span>
        ))}
      </div>
    </div>
  </section>
);
